import React from 'react';

const GridIcon = ({ color = '#7F38E9', width = 17, height = 17 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17 17" fill="none">
      <g clip-path="url(#clip0_17509_43824)">
        <path
          d="M6.875 1.53662H2.625C2.27982 1.53662 2 1.81644 2 2.16162V6.41162C2 6.7568 2.27982 7.03662 2.625 7.03662H6.875C7.22018 7.03662 7.5 6.7568 7.5 6.41162V2.16162C7.5 1.81644 7.22018 1.53662 6.875 1.53662Z"
          stroke={color}
          strokeWidth="1.20283"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 1.53662H10.125C9.77982 1.53662 9.5 1.81644 9.5 2.16162V6.41162C9.5 6.7568 9.77982 7.03662 10.125 7.03662H14.375C14.7202 7.03662 15 6.7568 15 6.41162V2.16162C15 1.81644 14.7202 1.53662 14.375 1.53662Z"
          stroke={color}
          strokeWidth="1.20283"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 9.03662H2.625C2.27982 9.03662 2 9.31644 2 9.66162V13.9116C2 14.2568 2.27982 14.5366 2.625 14.5366H6.875C7.22018 14.5366 7.5 14.2568 7.5 13.9116V9.66162C7.5 9.31644 7.22018 9.03662 6.875 9.03662Z"
          stroke={color}
          strokeWidth="1.20283"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 9.03662H10.125C9.77982 9.03662 9.5 9.31644 9.5 9.66162V13.9116C9.5 14.2568 9.77982 14.5366 10.125 14.5366H14.375C14.7202 14.5366 15 14.2568 15 13.9116V9.66162C15 9.31644 14.7202 9.03662 14.375 9.03662Z"
          stroke={color}
          strokeWidth="1.20283"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_17509_43824">
          <rect width="16" height="16" fill="white" transform="translate(0.5 0.0366211)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GridIcon;
